import { clientNameConfig } from "Config/themesConfig";
import { ThemeType } from "types/themeType";

/**
 * Validates and returns a theme type based on the provided value.
 *
 * This function checks the provided `value` against predefined theme types
 * defined in `clientNameConfig`. It normalizes the `value` to uppercase
 * and matches it with predefined constants. If the value matches one of the
 * predefined themes, it returns that theme. If there is no match, it defaults
 * to a predefined theme (SN).
 *
 * @param value - A string representing the theme to validate. This value is
 *                compared in a case-insensitive manner.
 *
 * @returns The validated theme type as a `ThemeType`. This is one of the
 *          predefined themes (`R2C` or `SN`). If the value does not match
 *          any predefined theme, `SN` is returned as the default.
 */
export function getThemeType(value: string | null | undefined): ThemeType {
  const { R2C, SN } = clientNameConfig;

  if (value == null) {
    return SN as ThemeType;
  }

  value = value.toUpperCase();

  if (value === "" || value === SN) {
    return SN as ThemeType;
  }

  if (value === R2C) {
    return R2C as ThemeType;
  }

  return SN as ThemeType; // Default to SN
}
